import angular from 'angular';
import * as _ from 'lodash';
import * as actions from '../../store/actions';
import * as $ from 'jquery';

angular.module('webTools').factory('Auth', ['$http', '$timeout', '$ngRedux', '$document', '$location', '$rootScope', '$window',
	function ($http, $timeout, $ngRedux, $document, $location, $rootScope, $window) {
		var _user = '';
		var _repository = '';
		var _loggedIn = false;
		var _workingFolderPermissions = {};
		var _timeout = '';
		var _webView = false;
		var _allowedNodes = [];

		const appendScripts = (widgets) => {
			_.each(widgets, function (component) {

				const scriptPath = `/widgets/${component.componentName}.js`;

				let componentScript = `<script src="${scriptPath}?nocache=${Date.now()}"></script>`

				if (angular.element(`script[src*="${scriptPath}"]`).length === 0) {
					$document.find('body').append(componentScript);
				}
			})
		}

		var getId = () => {
			let array = new Uint32Array(8)
			window.crypto.getRandomValues(array)
			let str = ''
			for (let i = 0; i < array.length; i++) {
				str += (i < 2 || i > 5 ? '' : '-') + array[i].toString(16).slice(-4)
			}
			return str
		}

		var setSession = () => {
			if (!localStorage.getItem('sessionId')) {
				localStorage.setItem('sessionId', getId())
			}
		}

		const handleChange = (e) => {
			if (e.key === 'sessionId') {
				if (e.newValue === null) {
					window.onbeforeunload = undefined;
					$location.url('/logout');
					$rootScope.$apply();
				}
			}
		}


		const getInternalSettings = () => {
			$http.post('/api/settings/read/dto/wt').then((res) => {
				const { domain } = res.data.data;
		
				$ngRedux.dispatch(actions.loadAppSettings(res.data.data));
			})
		}

		return {

			getUsername: function () { return _user; },
			getRepository: function () { return _repository; },
			loggedIn: function () { return _loggedIn; },
			getTimeout: function () { return _timeout; },
			getAllowedNodes: function () { return _allowedNodes; },
			isWebView: function () { return _webView },

			setPermissions: function (permissions) {
				_workingFolderPermissions = permissions;
			},

			getPermissions: function () {
				return _workingFolderPermissions;
			},

			checkSession: function (callback) {
				$http.get('/api/authentication/GetUserToken').then(function (response) {
					const data = response.data;
					if (data.authorized) {
						_user = data.id;
						_repository = data.repository;
						_loggedIn = true;
						_timeout = data.timeout
						_webView = data.readOnly;
						_allowedNodes = data.allowedNodes;

						$ngRedux.dispatch(actions.loadUserData(_.omit(data, ['portalWidgets'])));
						$ngRedux.dispatch(actions.loadPortal({ widgets: data.portalWidgets }, false));

						appendScripts(data.portalWidgets);
						setSession();

						$window.removeEventListener('storage', handleChange);
						$window.addEventListener('storage', handleChange);

						callback(true);
					} else {
						_loggedIn = false;
						callback(false);
					}
				})
			},

			login: function (path, type, user, pass, domain, server, repository, webLink, ssoToken, callback) {

				var req = {
					method: 'POST',
					url: '/api/authentication/login',
					data: { Path: path, LoginType: type, User: user, Password: pass, Domain: domain, Server: server, Repository: repository, WebLink: webLink }
				}

				if (type === 'oidc' || type === 'mobile-oidc') {
						req.headers = {
							Authorization: 'Bearer ' + ssoToken
						}
				}

				if (type === 'mobile-oidc') {
					req.data.LoginType = 'oidc';
				}

				return $http(req).then(function (response) {
					const data = response.data;
					
					if (type !== 'mobile-oidc') {
						if (data.authorized) {
							_user = data.id;
							_repository = data.repository;
							_timeout = data.timeout;
							_webView = data.readOnly;
							_allowedNodes = data.allowedNodes;
							if (data.id !== 'wtadmin') { _loggedIn = true; }

							$ngRedux.dispatch(actions.loadUserData(_.omit(data, ['portalWidgets'])));
							$ngRedux.dispatch(actions.loadPortal({ widgets: data.portalWidgets }, false));

							getInternalSettings();

							appendScripts(data.portalWidgets);
							setSession();

							$window.removeEventListener('storage', handleChange);
							$window.addEventListener('storage', handleChange);
						}
					}

					callback(data.authorized, data.redirect, data.message);

				}, (error) => { callback(false, error); })
			},

			clientSSOLogin: function (type, clientId, server, repository, ssoToken, isEdit, callback) {

				var req = {
					method: 'POST',
					url: '/api/sso/login',
					data: { LoginType: type, ClientID: clientId, Server: server, Repository: repository, IsEdit: isEdit }
				}

				if (type === 'oidc') {
					req.headers = {
						Authorization: 'Bearer ' + ssoToken
					}
				}

				return $http(req).then(function (response) {
					const data = response.data;
					callback(data.Authorized, data);
				}, (res) => { callback(false, res.data); })
			},
			changePassword: function (user, pass, newpass, server, repository, loginPath, callback) {

				const params = {
					user: user,
					password: pass,
					newPassword: newpass,
					server: server,
					repository: repository,
					path: loginPath
				}

				return $http.post('/api/authentication/changepassword', params)
					.then(function (response) {
						const data = response.data;
						if (data.authorized) {
							_user = data.id;
							_repository = data.repository;
							_timeout = data.timeout;
							_webView = data.readOnly;
							_allowedNodes = data.allowedNodes;
							if (data.id !== 'wtadmin') { _loggedIn = true; }

							$ngRedux.dispatch(actions.loadUserData(_.omit(data, ['portalWidgets'])));
							$ngRedux.dispatch(actions.loadPortal({ widgets: data.portalWidgets }, false));

							appendScripts(data.portalWidgets);
							setSession();

							$window.removeEventListener('storage', handleChange);
							$window.addEventListener('storage', handleChange);
						}

						callback(data.authorized, data.redirect, data.message);
					}, (error) => { callback(false, error); })
			},
			resetPassword: function (path, user, server, repository, callback) {
				return $http.post('/api/authentication/resetpassword', { Path: path, User: user, Server: server, Repository: repository })
					.then(function (data) {
						callback(data);
					}, (error) => { callback(false, error); })
			},
			loadSettings: function (forceUpdate, callback) {

				const appSettings = localStorage.getItem('appSettings');

				if (appSettings && !forceUpdate) {
					$ngRedux.dispatch(actions.loadAppSettings(JSON.parse(appSettings)));
					$timeout(() => callback())
				} else {
					$http.get('/api/app/getSettings')
						.then(function (res) {

							localStorage.setItem('appSettings', JSON.stringify(res.data));

							$ngRedux.dispatch(actions.loadAppSettings(res.data));

							$timeout(() => callback(res.data))
						}, (error) => { callback(false, error); })
				}

			},
			logout: function (callback) {

				$(".k-window-content").each(function () {
					$(this).data("kendoWindow").close();
				});

				_loggedIn = false;
				_allowedNodes = [];
				$ngRedux.dispatch(actions.loadUserData({ authorized: false, allowedNodes: [] }));
			}
		}
	}
]);